import React from 'react';
import Link from 'next/link';
// import Img from '../Img';

const Footer = () => {
    return (
        <footer className={`footer`}>
            <div className="container">
                <div className="row">
                    {/* <div className="d-none d-md-block col-md-2">
                        <div className="d-flex">
                            <Img src="/img/utr-logo-light.svg" />
                        </div>
                    </div> */}
                    <div className="col-12 col-md-10">
                        <div className="d-flex text-small links">
                            <ul className="list-inline">
                                <li className="list-inline-item">
                                    &copy; Copyright 2020 UTR &middot;
                                </li>
                                <li className="list-inline-item">
                                    <Link href="/privacy">
                                        <a className="text-gray">
                                            Privacy Policy &middot;
                                        </a>
                                    </Link>
                                </li>
                                <li className="list-inline-item">
                                    <Link href="/tos">
                                        <a className="text-gray">
                                            Terms &middot;
                                        </a>
                                    </Link>
                                </li>
                                <li className="list-inline-item">
                                    <Link href="/get-in-touch">
                                        <a className="text-gray">
                                            Contact Us
                                        </a>
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-12 col-md-2">
                        <div className="d-flex icons">
                            <a href="https://www.youtube.com/c/myutr" target="_blank" rel="noopener noreferrer">
                                <div className={`footer-icon youtube`} />
                            </a>
                            <a href="https://facebook.com/UniversalTennis" target="_blank" rel="noopener noreferrer">
                                <div className={`footer-icon facebook`} />
                            </a>
                            <a href="https://www.instagram.com/universaltennis/" target="_blank" rel="noopener noreferrer">
                                <div className={`footer-icon ig`} />
                            </a>
                            <a href="https://twitter.com/UniversalTennis" target="_blank" rel="noopener noreferrer">
                                <div className={`footer-icon twitter`} />
                            </a>
                        </div>
                    </div>
                </div>

            </div>
            <div className={`gradient`} />
        </footer>
    );
};

export default Footer;
